export const getNextSelectedCamera = (
  videoInput: MediaDeviceInfo[],
): string => {
  const storageSelectedCamera = localStorage.getItem('selectedCamera') || '';
  const deviceId = videoInput.length !== 0 ? videoInput[0].deviceId : '';

  return storageSelectedCamera || deviceId;
};
